import type { TRootState } from 'store';
import type { ISelector } from 'interfaces/Selector.interface';
import { createSelectorSlice } from 'redux/collections/helper/createSelector.slice';
import {
  currentPageDefault,
  itemsPerPageDefault,
} from 'redux/collections/consts/selectorDefaults.consts';

export const conversationsSlice = createSelectorSlice(
  'paginatedConversations',
  currentPageDefault,
  itemsPerPageDefault
);

const { actions, reducer } = conversationsSlice;

export const {
  setPagination,
  setNextPage,
  setSorting,
  setItemsPerPage,
  setFilters,
} = actions;

export const paginatedConversationsSelector = (state: TRootState): ISelector =>
  state.collectionConversations;

export default reducer;
